import { render, staticRenderFns } from "./ModalSendToJohnDeere.vue?vue&type=template&id=5967d8dd&scoped=true&"
import script from "./ModalSendToJohnDeere.vue?vue&type=script&lang=js&"
export * from "./ModalSendToJohnDeere.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendToJohnDeere.vue?vue&type=style&index=0&id=5967d8dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5967d8dd",
  null
  
)

export default component.exports